module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/quotas/quota-batchs/quota-movements-batch-list/quota-movements-batch-list.component.css
// module id = ./src/app/quotas/quota-batchs/quota-movements-batch-list/quota-movements-batch-list.component.css
// module chunks = main